// extracted by mini-css-extract-plugin
export default {"item":"QuotationListItem_item__kXybu","quotation":"QuotationListItem_quotation__AB4+w","author":"QuotationListItem_author__gyZCg","desc":"QuotationListItem_desc__6SIJZ"};